import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DuplicateLead } from './LeadDataGridStore';
import { Box } from '@mui/material';
import DuplicateLeadCard from './DuplicateLeadCard';

type Props = {
    leads: DuplicateLead[]
}

const DuplicateLeadTable = ({ leads }: Props) => {
    return (
        <Box>
            {leads.map(lead => <DuplicateLeadCard lead={lead} />)}
        </Box>
    )

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Rank</TableCell>
                        <TableCell>Type</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {leads.map((lead) => (
                        <TableRow
                            key={lead.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {lead.firstName}
                            </TableCell>
                            <TableCell>{lead.lastName}</TableCell>
                            <TableCell>{lead.company}</TableCell>
                            <TableCell>{lead.emailAddress}</TableCell>
                            <TableCell>{lead.rank}</TableCell>
                            <TableCell>{lead.keyType}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export { DuplicateLeadTable };
export default DuplicateLeadTable;